import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EvaluatorUploadLabresultComponent } from 'src/app/evaluator-dashboard/components/evaluator-upload-labresult/evaluator-upload-labresult.component';

@Component({
  selector: 'app-remarks-modal',
  templateUrl: './remarks-modal.component.html',
  styleUrls: ['./remarks-modal.component.scss']
})
export class RemarksModalComponent implements OnInit {
  displayedColumns: string[] = ["date", "name",];

  constructor(
    public dialogRef: MatDialogRef<EvaluatorUploadLabresultComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
  ) { }

  ngOnInit(): void {
  }

}
